import * as React from "react";
import { fromOthersNodeName } from "motw_core/Repositories/WorkflowRepository";
import { Style, StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { TurnPageLink } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/TurnPageLink/TurnPageLink";
import { keyframes } from "glamor";
import { IBookOfMindState } from "../../../Helpers/IBookOfMindState";
import { BookOfMind } from "source/app/presentation/MainPanel/Workflows/BookOfMind/BookOfMind";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";

export function EndOfQuotesTurnPageLink({
    turnPageLinkFadeInTime,
    state,
}: {
    turnPageLinkFadeInTime: number;
    state: IBookOfMindState;
}) {
    const turnPageLinkFadeInStyle = Style(`turnPageLinkFadeInStyle`, {
        animationName: keyframes({
            "0%": { opacity: 0 },
            "100%": { opacity: 1 },
        }),
        animationDuration: `1s`,
        animationDelay: `${turnPageLinkFadeInTime}ms`,
        animationFillMode: `forwards`,
        opacity: 0,
    });

    const isOnLastPage =
        state.remainingQuotesToDisplay.length <=
        state.numberOfQuotesToDisplay;

    const bottomLinkClass = StyleClass(`turnPageLinkAtBottom`, {
        display: `inline-flex`,
        alignItems: `center`,
        boxSizing: `border-box`,
        padding: `2px 8px`,
        border: `1px solid rgba(143, 107, 55, 0.16)`,
        borderRadius: `4px`,
        background: `rgba(255, 255, 255, 0.035)`,
        color: `rgba(235, 230, 211, 0.88)`,
        opacity: 0.74,
        lineHeight: `20px`,
        right: `12px`,
        position: `relative`,
        margin: `20px`,
        textShadow: `none`,
        transition: `background 120ms ease, border-color 120ms ease, color 120ms ease`,
        ":hover": {
            borderColor: `rgba(173, 139, 62, 0.34)`,
            background: `rgba(173, 139, 62, 0.18)`,
            color: `rgba(245, 226, 164, 0.98)`,
        },
        ":active": {
            borderColor: `rgba(143, 107, 55, 0.28)`,
            background: `rgba(0, 0, 0, 0.3)`,
        },
    });

    const bottomLinkClassLink = StyleClass(`turnPageLinkAtBottomLink`, {
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        width: `100%`,
        height: `100%`,
        textDecoration: `none`,
    });

    return (
        <div {...turnPageLinkFadeInStyle}>
            {isOnLastPage ? (
                <IconWithText
                    id="ShowAllQuotesAtBottom"
                    iconSuffix={EGlyphicon.book}
                    whenClicked={() => BookOfMind(fromOthersNodeName)}
                    displayAsBlock={false}
                    withClass={bottomLinkClass}
                    linkClass={bottomLinkClassLink}
                >
                    Show All
                </IconWithText>
            ) : (
                <TurnPageLink
                    state={state}
                    withClass={bottomLinkClass}
                    linkClass={bottomLinkClassLink}
                />
            )}
        </div>
    );
}
